module.exports = __webpack_public_path__ + "img/art_3_1.5cc25b65.jpeg";